module.exports = __webpack_public_path__ + "static/img/bg-en.bc2e7add.webp";